import type { ConversationStatus } from '@revocom/webchat-sdk';

const BANNER_COPY: Partial<
  Record<
    ConversationStatus,
    { emoji: string; title: string; subtitle?: string }
  >
> = {
  PENDING: {
    emoji: '👋',
    title: 'Thanks for sharing your details.',
    subtitle: 'Send a message whenever you are ready.',
  },
  OPEN: {
    emoji: '💬',
    title: "We've received your message.",
    subtitle: 'An agent will assist you shortly.',
  },
  IN_PROGRESS: {
    emoji: '🟢',
    title: 'An agent is assisting you.',
  },
  CLOSED: {
    emoji: '✅',
    title: 'This discussion has ended.',
    subtitle: 'You can review previous messages or start a new conversation.',
  },
};

export function ConversationStatusBanner({
  status,
}: {
  status: ConversationStatus;
}) {
  const key = status;
  const copy = BANNER_COPY[key];
  if (!copy) return null;

  return (
    <div className="rw-status-banner" role="status">
      <span className="rw-status-banner-emoji" aria-hidden>
        {copy.emoji}
      </span>
      <div className="rw-status-banner-text">
        <div className="rw-status-banner-title">{copy.title}</div>
        {copy.subtitle ? (
          <div className="rw-status-banner-subtitle">{copy.subtitle}</div>
        ) : null}
      </div>
    </div>
  );
}
